import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { Subject } from 'rxjs/Rx';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { Anamnesis } from '../models/';

@Injectable()
export class AnamnesisService extends RESTService<any> {

  public anamnesis: Anamnesis;
  public anamnesi: Anamnesis[];

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  /**
   * obtenerMotivos: obtiene el listado completo de Anamnesis de un paciente
   * @param pacienteId: string
   * @param visita: string
   * @return any
   */
  obtenerAnamnesis(pacienteId: string, visita: string): any {
    return this._http.post(environment.api_host + 'anamnesisConsulta/obtenerAnamnesisConsulta', {
      numeroExpediente: pacienteId,
      visita: visita,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * guardarAnamnesis
   * @param params: object
   * @return boolean
   */
  guardarAnamnesis(params: any): Observable<string> {
    return this._http.post(environment.api_host + 'anamnesisConsulta/guardarAnamnesis', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado !== undefined) {
        return respuesta.resultado;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }
}



// WEBPACK FOOTER //
// ./src/services/anamnesis.service.ts